//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, litigationDocketCaseUrl } from "@/services/constants";
import TimeLineOperations from "../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import Swal from 'sweetalert2'
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");

// ค่าการตัดสินใจของลูกค้า (เก็บลง DB เป็น string)
const DECISION = {
    AWAITING: "awaiting",
    PROCEED: "proceed",
    DECLINED: "declined",
};

// D · ประเภทนัด "อื่นๆ / Other" (ค่าภายใน ไม่ได้ส่ง API — ส่งข้อความที่ผู้ใช้พิมพ์แทน)
const OTHER_TYPE = "__other__";

// D · สถานะของนัดหมาย / กำหนดส่งเอกสาร
const SCHEDULE_STATUS = [
    { value: "not_started", text: "Not started", tone: "grey" },
    { value: "in_progress", text: "In progress", tone: "blue" },
    { value: "completed", text: "Completed", tone: "green" },
    { value: "overdue", text: "Overdue", tone: "red" },
    { value: "cancelled", text: "Cancelled", tone: "dark" },
];

export default {
    name: "CaseDocket",
    data() {
        return {
            quotationscheckstatus: '',
            statusCloseEditMode: false,
            invoiceList: [],
            invoiceSelectList: [],
            invoiceMenu: false,
            invoiceMenuPay: false,
            formValid: false,
            // date pickers ของ Section A
            adviceDateMenu: false,
            decisionDateMenu: false,
            form: {
                // ---------- A · Advice & Client Decision ----------
                adviceDate: moment().format("YYYY-MM-DD"),
                advisingLawyerId: null,
                adviceStatus: "draft",
                adviceSummary: "",
                recommendedAction: "",
                clientDecision: DECISION.AWAITING,
                decisionDate: "",
                clientNote: "",
                // ---------- B · Case Identification ----------
                internalCaseNo: "",
                blackNo: "",
                clientId: null,
                redNo: "",
                charge: "",
                court: null,
                department: null,
                caseType: null,
                courtLevel: "ศาลชั้นต้น",
                lawyerId: null,
                claimAmount: "",
                plaintiffs: "",
                defendants: "",
                // นัดหมาย (Section D · Case appointments) — ฟิลด์เดิม topic/date/time ยังส่ง API เดิม
                // ฟิลด์ใหม่ (endTime, courtId, location, attendees, reminders, status, note) รอต่อ API
                hearings: [],
                // กำหนดส่งเอกสาร (Section D · Document deadlines) — ยังไม่ต่อ API
                deadlines: [],
                remark: "",
                caseStatus: 0,
                customerName: "",
                currency: "",
                salesOrderId: "",
                price: "",
                invoiceStatus: "",
                invoiceNo: "",
                invoiceId: "",
                invoiceDate: "",
                dueDate: "",
                files: [],
            },
            // ข้อความที่แสดงในช่องทุนทรัพย์ (มี , คั่นหลักพัน)
            claimAmountDisplay: "",
            // รหัสคดีที่โหลดมาจาก server (ใช้เตือนก่อนเปลี่ยนเป็น Do not proceed)
            originalInternalCaseNo: "",
            adviceStatusList: [
                { value: "draft", text: "Draft / ร่าง" },
                { value: "in_preparation", text: "In preparation / กำลังจัดทำ" },
                { value: "under_review", text: "Under review / อยู่ระหว่างตรวจสอบ" },
                { value: "approved", text: "Approved / อนุมัติแล้ว" },
                { value: "provided", text: "Provided to client / ส่งคำแนะนำให้ลูกค้าแล้ว" },
                { value: "withdrawn", text: "Withdrawn / ยกเลิก" },
            ],
            clientDecisionOptions: [
                { value: DECISION.AWAITING, label: "Awaiting decision" },
                { value: DECISION.PROCEED, label: "Proceed with case" },
                { value: DECISION.DECLINED, label: "Do not proceed" },
            ],
            deletedHearings: [],
            deletedDeadlines: [],
            // DEV: แสดงปุ่ม Test data เฉพาะตอนพัฒนา (npm run serve) — build production จะซ่อนเอง
            showDevTools: process.env.NODE_ENV !== "production",
            // ---------- การ์ด A–F แบบพับ/กาง (accordion) ----------
            openSections: { A: true, B: true, C: true, D: true, E: true, F: true },
            // ---------- D · Case schedule & deadlines (UI) ----------
            scheduleTab: 0,
            // ฟอร์มนัด/กำหนดส่งเปิดอยู่เสมอ (index -1 = เพิ่มใหม่, >= 0 = แก้ไขรายการนั้น)
            apptEditor: { open: true, index: -1, submitted: false },
            apptDraft: {},
            deadlineEditor: { open: true, index: -1, submitted: false },
            deadlineDraft: {},
            // ประเภทนัด — value (ภาษาไทย) คือค่าที่เก็บลง topic และส่ง API เดิม
            OTHER_TYPE,
            appointmentTypeList: [
                ["นัดพิจารณาคดี", "Court hearing"],
                ["นัดสืบพยานโจทก์", "Plaintiff witness examination"],
                ["นัดสืบพยานจำเลย", "Defendant witness examination"],
                ["นัดไกล่เกลี่ย", "Mediation"],
                ["นัดชี้สองสถาน", "Settlement of issues"],
                ["นัดฟังคำพิพากษา", "Judgment hearing"],
                ["กำหนดยื่นเอกสาร", "Filing deadline"],
                ["นัดหมายกับลูกค้า", "Client meeting"],
                [OTHER_TYPE, "Other", "อื่นๆ"],
            ].map(([value, en, th]) => ({ value, en, th: th || value, text: `${th || value} / ${en}` })),
            // สถานะ — ใช้ชุดเดียวกันทั้งนัดหมายและกำหนดส่งเอกสาร
            appointmentStatusList: SCHEDULE_STATUS,
            deadlineStatusList: SCHEDULE_STATUS,
            appointmentReminderOptions: [
                { value: "7d", label: "7 days before", short: "7 days" },
                { value: "1d", label: "1 day before", short: "1 day" },
                { value: "2h", label: "2 hours before", short: "2 hours" },
            ],
            deadlineReminderOptions: [
                { value: "7d", label: "7 days before", short: "7 days" },
                { value: "3d", label: "3 days before", short: "3 days" },
                { value: "1d", label: "1 day before", short: "1 day" },
            ],
            pendingFiles: [],
            additionalLawyers: [],
            originalAdditionalLawyers: [],
            showCoLawyer: false,
            clientList: [],
            courtList: [],
            departmentList: [],
            caseTypeList: [],
            courtLevelList: [],
            lawyerList: [],
            salesOrderList: [],
            invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],

            rules: {
                required: (v) => !!v || "จำเป็นต้องกรอก",
            },
            deletedFiles: [],
            //timeline
            timelineStatus: 0,
            status_note: "",
            visible_check: false,
            dialogDelete: false,
            timeline_case_id: 0,
            module_name: "Dispute Resolution",
            modeOperations: "",
            tabselect: 0,
            reportlist: [],
            statuslist: [],

        };
    },
    components: {
        TimeLineOperations,
        InvoiceSectionPanel
    },
    computed: {
        nonCloseStatus() {
            return this.modeOperations === "Edit" ? !this.statusCloseEditMode : true;
        },
        // ---------- สถานะการตัดสินใจของลูกค้า ----------
        isAwaiting() {
            return this.form.clientDecision === DECISION.AWAITING;
        },
        isProceed() {
            return this.form.clientDecision === DECISION.PROCEED;
        },
        isDeclined() {
            return this.form.clientDecision === DECISION.DECLINED;
        },
        // ช่องใน Case Identification / คู่ความ / วันนัด / เอกสารแนบ กรอกได้เฉพาะ Proceed with case
        caseLocked() {
            return !this.isProceed;
        },
        // Do not proceed และไม่มีข้อมูลคดี → ช่องลูกค้าถูกซ่อน ให้ลูกค้าตาม Sales Order
        clientFollowsSO() {
            return this.isDeclined && !this.hasCaseData;
        },
        // คดีนี้มีข้อมูล Case Identification อยู่แล้วหรือไม่
        // → ถ้ามี จะไม่ล้างทิ้งไม่ว่าลูกค้าตัดสินใจแบบไหน (Do not proceed แสดงแบบ read-only)
        // หมายเหตุ: ไม่นับ clientId เพราะ Do not proceed ตั้งลูกค้าอัตโนมัติจาก Sales Order
        hasCaseData() {
            const f = this.form;
            const filled = (v) => v !== null && v !== undefined && String(v).trim() !== "";
            return (
                filled(f.internalCaseNo) ||
                filled(f.blackNo) ||
                filled(f.redNo) ||
                filled(f.charge) ||
                filled(f.court) ||
                filled(f.department) ||
                filled(f.caseType) ||
                filled(f.claimAmount) ||
                filled(f.lawyerId) ||
                filled(f.plaintiffs) ||
                filled(f.defendants) ||
                filled(f.remark) ||
                f.files.length > 0 ||
                this.additionalLawyers.length > 0 ||
                f.hearings.some(h => (h.id && h.id !== 0) || filled(h.topic) || filled(h.date))
            );
        },
        // ช่อง required ของคดี บังคับเฉพาะตอน Proceed เท่านั้น
        caseRequiredRules() {
            return this.isProceed ? [this.rules.required] : [];
        },
        requestPaymentDisabled() {
            const price = Number(this.form.price);
            const salesOrderId = Number(this.form.salesOrderId);
            const customerID = Number(this.form.clientId);

            const isPriceValid = !isNaN(price) && price > 0;
            const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
            const isCustomerIdValid = !isNaN(customerID) && customerID > 0;

            // วางบิลได้ทุกสถานะยกเว้น Awaiting decision (ล็อกอยู่)
            return !(!this.isAwaiting && isPriceValid && isSalesOrderIdValid && isCustomerIdValid);
        },
        // ---------- หัวการ์ด A–F: badge + สรุปข้อมูลตอนพับ ----------
        allSectionsOpen() {
            return Object.values(this.openSections).every(Boolean);
        },
        allSectionsClosed() {
            return !Object.values(this.openSections).some(Boolean);
        },
        decisionLabel() {
            const o = this.clientDecisionOptions.find(x => x.value === this.form.clientDecision);
            return o ? o.label : "—";
        },
        decisionTone() {
            return { awaiting: "amber", proceed: "green", declined: "red" }[this.form.clientDecision] || "grey";
        },
        caseBadge() {
            if (this.isAwaiting) return { tone: "amber", text: "Locked · Awaiting client decision" };
            if (this.isDeclined) return { tone: "grey", text: "Not created · Client declined" };
            return { tone: "blue", text: "In progress" };
        },
        summaryA() {
            const st = this.adviceStatusList.find(x => x.value === this.form.adviceStatus);
            const parts = [
                st ? st.text.split(" / ")[0] : "",
                this.formatDate(this.form.adviceDate),
                this.lawyerName(this.form.advisingLawyerId),
            ];
            return parts.filter(Boolean).join(" · ") || "ยังไม่ได้กรอก";
        },
        summaryB() {
            if (this.isDeclined) return "No case ID has been generated";
            const client = this.clientList.find(x => x.id === this.form.clientId);
            const parts = [
                this.form.internalCaseNo ? `Case ID ${this.form.internalCaseNo}` : "New case",
                client ? client.name : "",
                this.courtName(this.form.court),
                this.form.blackNo ? `คดีดำ ${this.form.blackNo}` : "",
            ];
            return parts.filter(Boolean).join(" · ");
        },
        summaryC() {
            const count = (t) => String(t || "").split("\n").map(x => x.trim()).filter(Boolean).length;
            const p = count(this.form.plaintiffs);
            const d = count(this.form.defendants);
            if (!p && !d) return "ยังไม่ระบุคู่ความ";
            return `โจทก์ ${p} ราย · จำเลย ${d} ราย`;
        },
        summaryD() {
            const a = this.sortedAppointments.length;
            const d = this.sortedDeadlines.length;
            const parts = [
                `${a} appointment${a === 1 ? "" : "s"}`,
                `${d} deadline${d === 1 ? "" : "s"}`,
            ];
            const next = this.sortedAppointments.find(r => !this.isPast(r.item.date, r.item.endTime || r.item.time));
            if (next) {
                parts.push(`Next: ${next.item.topic || "นัด"} ${this.formatDate(next.item.date)} ${next.item.time || ""}`.trim());
            }
            return parts.join(" · ");
        },
        overdueDeadlineCount() {
            return this.form.deadlines.filter(d => this.isDeadlineOverdue(d)).length;
        },
        summaryE() {
            const n = this.form.files.length;
            const st = this.statuslist.find(x => x.module_id === this.form.caseStatus);
            const parts = [
                `${n} file${n === 1 ? "" : "s"}`,
                String(this.form.remark || "").trim() ? "มีหมายเหตุ" : "ไม่มีหมายเหตุ",
                st ? `สถานะคดี: ${st.descriptions}` : "",
            ];
            return parts.filter(Boolean).join(" · ");
        },
        // F (ตอนพับ): แสดงแค่ Quotation ID + จำนวน invoice
        summaryF() {
            const parts = [];
            if (this.form.salesOrderId) {
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                parts.push(`Quotation ID ${so && so.doc_no ? so.doc_no : this.form.salesOrderId}`);
            }
            const n = this.invoiceList.length;
            parts.push(`${n} invoice${n === 1 ? "" : "s"}`);
            return parts.join(" · ");
        },

        // ---------- D · Case schedule & deadlines ----------
        responsibleLawyerName() {
            return this.lawyerName(this.form.lawyerId);
        },
        // ผู้เข้าร่วมเพิ่มเติม: ตัดทนายผู้รับผิดชอบออก (ได้รับนัดอัตโนมัติอยู่แล้ว)
        // TODO: เปลี่ยนเป็นรายชื่อพนักงานทั้งหมดเมื่อมี API
        attendeeOptions() {
            return this.lawyerList.filter(l => l.id !== this.form.lawyerId);
        },
        // เรียงตามวัน/เวลา (เก็บ index เดิมไว้ใช้ตอนแก้ไข/ลบ)
        sortedAppointments() {
            return this.form.hearings
                .map((item, index) => ({ item, index }))
                .filter(r => r.item.date || r.item.topic)
                .sort((a, b) => `${a.item.date} ${a.item.time}`.localeCompare(`${b.item.date} ${b.item.time}`));
        },
        sortedDeadlines() {
            return this.form.deadlines
                .map((item, index) => ({ item, index }))
                .sort((a, b) => `${a.item.dueDate} ${a.item.dueTime}`.localeCompare(`${b.item.dueDate} ${b.item.dueTime}`));
        },
        // ลำดับที่แสดงในแท็บ: ฟอร์มเพิ่มใหม่ → หัวข้อ → (ว่าง) → รายการ
        // ฟอร์มจะ render ต่อท้าย entry ที่ index ตรงกับรายการที่กำลังแก้ (-1 = ฟอร์มเพิ่มใหม่ด้านบน)
        appointmentEntries() {
            return this.buildEntries(this.sortedAppointments);
        },
        deadlineEntries() {
            return this.buildEntries(this.sortedDeadlines);
        },
        apptErrors() {
            const e = {};
            if (!this.apptEditor.submitted) return e;
            const d = this.apptDraft;
            if (!d.topicType) e.topic = "จำเป็นต้องเลือก";
            else if (d.topicType === OTHER_TYPE && !String(d.topicOther || "").trim()) e.topicOther = "กรุณาระบุประเภทนัด";
            if (!d.date) e.date = "จำเป็นต้องกรอก";
            if (!d.time) e.time = "จำเป็นต้องกรอก";
            if (d.time && d.endTime && d.endTime <= d.time) e.endTime = "ต้องหลังเวลาเริ่ม";
            return e;
        },
        deadlineErrors() {
            const e = {};
            if (!this.deadlineEditor.submitted) return e;
            const d = this.deadlineDraft;
            if (!d.task || !String(d.task).trim()) e.task = "จำเป็นต้องกรอก";
            if (!d.dueDate) e.dueDate = "จำเป็นต้องกรอก";
            if (!d.assigneeId) e.assigneeId = "จำเป็นต้องเลือก";
            return e;
        },
        coLawyerList() {
            // ตัดทนายหลักออกจากตัวเลือกทนายร่วม
            return this.lawyerList.filter(l => l.id !== this.form.lawyerId);
        },
    },
    created() {
        // D · ฟอร์มนัด/กำหนดส่งเปิดไว้ตั้งแต่แรก (default แท็บ Case appointments)
        this.closeAppointmentEditor();
        this.closeDeadlineEditor();
    },
    watch: {
        // ล็อก (ยังไม่ Proceed) → กลับแท็บ Case appointments และยกเลิกการแก้ไขที่ค้างอยู่
        caseLocked(locked) {
            if (!locked) return;
            this.scheduleTab = 0;
            this.closeAppointmentEditor();
            this.closeDeadlineEditor();
        },
        // ศาล / ทนายใน Section B โหลดหรือเปลี่ยนทีหลัง → เติมค่าเริ่มต้นให้ฟอร์มเพิ่มใหม่ที่ยังว่าง
        "form.court"(val) {
            if (this.apptEditor.index === -1 && !this.apptDraft.courtId) this.apptDraft.courtId = val ?? null;
        },
        "form.lawyerId"(val) {
            if (this.deadlineEditor.index === -1 && !this.deadlineDraft.assigneeId) this.deadlineDraft.assigneeId = val ?? null;
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            // ----------------- Check Authorize ID ---------------------------
            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            // ----------------- Resolve Current Route Path -------------------
            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            // ----------------- Fetch Authorization --------------------------
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            // ----------------- Check Login Status ---------------------------
            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }

            await this.loaddataLitigationCourt()
            await this.loaddataLitigationCourtLevel()
            await this.loaddataLitigationCourtCasetype()
            await this.loaddataLitigationCourtDepartment()
            await this.loaddataClientList()
            await this.loaddataLawyerList()
            await this.loaddataSalesOrder()
            await this.loadDataInvoiceSelect()
            await this.loaddataLitigationCourtStatus()
            // ----------------- Resolve Mode (New / Edit) --------------------
            const id = this.$route.params.id;
            if (id === "new") {
                // โหมดสร้างใหม่ — เริ่มที่ Awaiting decision, ยังไม่ออกรหัสคดี
                this.modeOperations = "New";
            } else {
                // โหมดแก้ไข — id เป็นตัวเลข
                this.modeOperations = "Edit";
                this.timeline_case_id = Number(id);
                await this.loadData(id);
                await this.loadFile(id);
                await this.loadAdditionalLawyers(id);
                await this.loadHearings(id);
                await this.loadDeadlines(id);
                await this.loadDataInvoice(id);
            }

        } catch (error) {
            console.error("mounted() error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        } finally {
            this.$hideLoader();
        }
    },
    beforeRouteUpdate(to, from, next) {
        // route เปลี่ยน id แต่ component ตัวเดิม -> สั่งรีโหลดหน้าทั้งหมด
        next();
        location.reload();
    },
    methods: {

        async loaddataLitigationCourt() {
            try {
                const res = await api.dispute_resolution_getall_court();
                this.courtList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourt error:", error);
            }
        },

        async loaddataLitigationCourtLevel() {
            try {
                const res = await api.dispute_resolution_getall_courtlevel();
                this.courtLevelList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtLevel error:", error);
            }
        },
        async loaddataLitigationCourtCasetype() {
            try {
                const res = await api.dispute_resolution_getall_courttype();
                this.caseTypeList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtCasetype error:", error);
            }
        },
        async loaddataLitigationCourtDepartment() {
            try {
                const res = await api.dispute_resolution_getall_courtdepartment();
                this.departmentList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtDepartment error:", error);
            }
        },
        async loaddataClientList() {
            try {
                const res = await api.dispute_resolution_get_clienList(Number(localStorage.getItem(server.COMPANYID)));
                this.clientList = res.data || [];
            } catch (error) {
                console.error("loaddataClientList error:", error);
            }
        },
        async loaddataLawyerList() {
            try {
                const res = await api.dispute_resolution_get_lawyerList(Number(localStorage.getItem(server.COMPANYID)));
                this.lawyerList = res.data.data || [];
            } catch (error) {
                console.error("loaddataLawyerList error:", error);
            }
        },
        async loaddataSalesOrder() {
            try {
                const res = await api.dispute_resolution_get_quotationsList(Number(localStorage.getItem(server.COMPANYID)));
                this.salesOrderList = res.data.data || [];

            } catch (error) {
                console.error("loaddataSalesOrder error:", error);
            }
        },
        async loadData(id) {
            try {
                const res = await api.dispute_resolution_getbyid_docket(Number(id));
                const d = res.data[0];

                // ---------- A · Advice & Client Decision ----------
                this.form.adviceDate = d.advice_date ? String(d.advice_date).slice(0, 10) : "";
                this.form.advisingLawyerId = d.advising_lawyer_id || null;
                this.form.adviceStatus = d.advice_status || "draft";
                this.form.adviceSummary = d.advice_summary || "";
                this.form.recommendedAction = d.recommended_action || "";
                // ข้อมูลเก่าก่อนมีฟีเจอร์นี้ (ไม่มี client_decision) แต่มีรหัสคดีแล้ว → ถือว่า Proceed
                this.form.clientDecision = d.client_decision
                    || (d.internal_case_no ? DECISION.PROCEED : DECISION.AWAITING);
                this.form.decisionDate = d.decision_date ? String(d.decision_date).slice(0, 10) : "";
                this.form.clientNote = d.client_note || "";

                // ---------- B · Case Identification ----------
                this.form.internalCaseNo = d.internal_case_no || "";
                this.originalInternalCaseNo = this.form.internalCaseNo;
                this.form.blackNo = d.black_no || "";
                this.form.clientId = d.client_id || null;
                this.form.redNo = d.red_no || "";
                this.form.charge = d.charge || "";
                this.form.court = d.court ?? null;
                this.form.department = d.department ?? null;
                this.form.caseType = d.case_type ?? null;
                this.form.courtLevel = d.court_level ?? "ศาลชั้นต้น";
                this.form.lawyerId = d.lawyer_id || null;
                this.form.claimAmount = d.claim_amount != null ? this.normalizeAmount(d.claim_amount) : "";
                this.claimAmountDisplay = this.formatAmount(this.form.claimAmount);
                this.form.plaintiffs = d.plaintiffs || "";
                this.form.defendants = d.defendants || "";
                this.form.remark = d.remark || "";
                this.form.caseStatus = d.case_status != null ? Number(d.case_status) : 0;

                const selectedItem = this.statuslist.find(
                    item => Number(item.module_id) === Number(this.form.caseStatus)
                );
                if (selectedItem) {
                    this.statusCloseEditMode = selectedItem.status === "ปิดคดี";
                    this.timelineStatus = Number(selectedItem.timeline_status_id);
                } else {
                    this.statusCloseEditMode = false;
                    this.timelineStatus = 0;
                }

                this.form.salesOrderId = d.sales_order_id || "";
                // ค้น object เองตอนโหลดข้อมูลเดิม เพราะไม่ได้ผ่าน event จาก component
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                this.onSelectSO(so || null);
            } catch (error) {
                console.error("loadData error:", error);
            }
        },
        async loadAdditionalLawyers(id) {
            try {
                const res = await api.dispute_resolution_getbyid_additional_lawyers(id)
                this.additionalLawyers = res.data.map(item => item.user_id);
                this.originalAdditionalLawyers = [...this.additionalLawyers]; // เก็บค่าเดิม
                if (this.additionalLawyers.length > 0) {
                    this.showCoLawyer = true;
                }
            } catch (error) {
                console.error("loadAdditionalLawyers error:", error);
            }
        },
        async loadHearings(id) {
            try {
                const res = await api.dispute_resolution_getbyid_hearings(id)
                const rows = (res.data || []).map(item => ({
                    id: item.id,
                    topic: item.topic || "",
                    date: item.date ? String(item.date).slice(0, 10) : "",
                    time: item.time ? item.time.slice(0, 5) : "",
                    // ฟิลด์ใหม่ (ยังไม่มีใน API — ใช้ค่าเริ่มต้นไปก่อน)
                    endTime: item.end_time ? item.end_time.slice(0, 5) : "",
                    courtId: item.court_id ?? this.form.court ?? null,
                    location: item.location || "",
                    attendees: (item.attendees || []).map(Number),
                    reminders: item.reminders || ["7d", "1d", "2h"],
                    status: item.status || "not_started",
                    note: item.note || "",
                }));
                this.form.hearings = rows;

            } catch (error) {
                console.error("loadHearings error:", error);
            }
        },
        async loadDeadlines(id) {
            try {
                const res = await api.dispute_resolution_getbyid_deadlines(id);
                this.form.deadlines = (res.data || []).map(item => ({
                    id: item.id,
                    task: item.task || "",
                    dueDate: item.due_date ? String(item.due_date).slice(0, 10) : "",
                    dueTime: item.due_time ? item.due_time.slice(0, 5) : "",
                    assigneeId: item.assignee_id != null ? Number(item.assignee_id) : null,
                    reminders: item.reminders || ["7d", "3d", "1d"],
                    status: item.status || "not_started",
                }));
            } catch (error) {
                console.error("loadDeadlines error:", error);
            }
        },
        // ---------- D · ข้อมูลที่ส่ง API ----------
        // นัดหมาย → litigation_hearings (+ attendees → litigation_hearing_attendees ฝั่ง backend sync ให้)
        hearingPayload(item) {
            const empty = (v) => v === "" || v === undefined || v === null;
            return {
                topic: item.topic,
                date: item.date,
                time: item.time,
                end_time: empty(item.endTime) ? null : item.endTime,
                court_id: empty(item.courtId) ? null : Number(item.courtId),
                location: empty(item.location) ? null : String(item.location).trim(),
                reminders: item.reminders || [],
                status: item.status || "not_started",
                note: empty(item.note) ? null : String(item.note).trim(),
                attendees: (item.attendees || []).map(Number),
                user_update: Number(localStorage.getItem(server.USER_ID)),
            };
        },
        // กำหนดส่งเอกสาร → litigation_deadlines
        deadlinePayload(item) {
            return {
                task: item.task,
                due_date: item.dueDate,
                due_time: item.dueTime ? item.dueTime : null,
                assignee_id: Number(item.assigneeId),
                reminders: item.reminders || [],
                status: item.status || "not_started",
                user_update: Number(localStorage.getItem(server.USER_ID)),
            };
        },
        // บันทึกนัด + กำหนดส่งทั้งหมดของคดี (ใช้ทั้งโหมด New และ Edit)
        async saveScheduleItems(docketId) {
            const userId = Number(localStorage.getItem(server.USER_ID));

            // ----- นัดหมาย -----
            for (const hid of this.deletedHearings) {
                await api.dispute_resolution_delete_hearings(hid);
            }
            for (const item of this.form.hearings) {
                if (!item.date || !item.time || !item.topic) continue;   // ข้ามแถวที่กรอกไม่ครบ
                const data = this.hearingPayload(item);
                if (item.id && item.id !== 0) {
                    await api.dispute_resolution_update_hearings(item.id, data);
                } else {
                    const res = await api.dispute_resolution_add_hearings({
                        ...data, litigation_docket_id: Number(docketId), user_create: userId,
                    });
                    if (res && res.data && res.data.id) item.id = res.data.id;   // กันบันทึกซ้ำถ้ากด SAVE อีกรอบ
                }
            }
            this.deletedHearings = [];

            // ----- กำหนดส่งเอกสาร -----
            for (const did of this.deletedDeadlines) {
                await api.dispute_resolution_delete_deadlines(did);
            }
            for (const item of this.form.deadlines) {
                if (!item.task || !item.dueDate || !item.assigneeId) continue;
                const data = this.deadlinePayload(item);
                if (item.id && item.id !== 0) {
                    await api.dispute_resolution_update_deadlines(item.id, data);
                } else {
                    const res = await api.dispute_resolution_add_deadlines({
                        ...data, litigation_docket_id: Number(docketId), user_create: userId,
                    });
                    if (res && res.data && res.data.id) item.id = res.data.id;
                }
            }
            this.deletedDeadlines = [];
        },
        // มีฟอร์มนัด / กำหนดส่ง กรอกค้างไว้แต่ยังไม่กด Save appointment / Save deadline หรือไม่
        hasUnsavedScheduleDraft() {
            if (this.caseLocked) return false;
            const a = this.apptDraft || {};
            const d = this.deadlineDraft || {};
            const apptDirty = this.apptEditor.index > -1
                || !!(a.topicType || a.date || a.time || String(a.location || "").trim() || String(a.note || "").trim());
            const dlDirty = this.deadlineEditor.index > -1
                || !!(String(d.task || "").trim() || d.dueDate || d.dueTime);
            return apptDirty || dlDirty;
        },
        // ถามก่อนบันทึก: รวมรายการที่ค้างไว้ด้วย / ทิ้ง / กลับไปแก้
        // คืนค่า true = บันทึกต่อได้, false = หยุด
        async resolveUnsavedScheduleDraft() {
            if (!this.hasUnsavedScheduleDraft()) return true;
            const r = await Swal.fire({
                icon: "question",
                title: "มีนัด / กำหนดส่งที่ยังไม่ได้กด Save",
                html: "ใน Section D มีข้อมูลที่กรอกค้างไว้<br/>ต้องการบันทึกรวมไปด้วยหรือไม่",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "บันทึกรวมด้วย",
                denyButtonText: "ไม่บันทึกรายการนี้",
                cancelButtonText: "กลับไปแก้",
                confirmButtonColor: "#0e3a5f",
                denyButtonColor: "#c0392b",
                cancelButtonColor: "#8a94a3",
                reverseButtons: true,
            });
            if (r.isDismissed) return false;
            if (r.isDenied) {
                this.closeAppointmentEditor();
                this.closeDeadlineEditor();
                return true;
            }
            // บันทึกรวมด้วย → ตรวจแล้วเพิ่มเข้า list (ถ้ากรอกไม่ครบ พาไปดูช่องที่ขาด)
            const a = this.apptDraft || {};
            const apptDirty = this.apptEditor.index > -1 || !!(a.topicType || a.date || a.time);
            if (apptDirty) {
                this.saveAppointment();
                if (Object.keys(this.apptErrors).length) {
                    this.openSections.D = true;
                    this.scheduleTab = 0;
                    return false;
                }
            }
            const d = this.deadlineDraft || {};
            const dlDirty = this.deadlineEditor.index > -1 || !!(String(d.task || "").trim() || d.dueDate);
            if (dlDirty) {
                this.saveDeadline();
                if (Object.keys(this.deadlineErrors).length) {
                    this.openSections.D = true;
                    this.scheduleTab = 1;
                    return false;
                }
            }
            return true;
        },
        async loadDataInvoice(id) {
            try {
                var dataserach = {
                    module_name: 'Litigations',
                    module_id: id,
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                }
                const res = await api.dispute_resolution_get_invoiceList({
                    params: dataserach
                })
                this.invoiceList = res.data.data || [];
            } catch (error) {
                console.error("loadDataInvoice error:", error);
            }
        },
        async loadDataInvoiceSelect() {
            try {
                const id = this.$route.params.id;
                const isEdit = id && id !== "new";
                const res = await api.billing_expense_getInvoiceSelectList(
                    Number(localStorage.getItem(server.COMPANYID)),
                    isEdit ? "Litigations" : null,
                    isEdit ? Number(id) : null
                );
                this.invoiceSelectList = res.data.data || [];
            } catch (error) {
                console.error("loadDataInvoiceSelect error:", error);
            }
        },
        async loadFile(id) {
            try {
                const res = await api.dispute_resolution_load_file(id, Number(localStorage.getItem(server.COMPANYID)));

                this.form.files = (res.data || []).map(item => ({
                    id: item.id,
                    name: item.file_name,
                    url: `${litigationDocketCaseUrl}/${item.module_id}/${item.file_name}`,
                    raw: null,        // ไฟล์เดิมจาก server ไม่มี raw
                    isExisting: true, // ธงบอกว่าเป็นไฟล์เก่า (เผื่อ logic ตอน save/delete)
                }));
            } catch (error) {
                console.error("loadFile error:", error);
            }
        },
        //timelinestatus
        closeDelete() {
            this.dialogDelete = false;
        },
        deleteItemConfirm() {
            this.tabselect = 1;
            this.dialogDelete = false;
        },

        handleRequestStatus(value) {
            this.form.caseStatus = Number(value)
        },
        sendToStatus(value) {
            const selectedItem = this.statuslist.find(
                item => item.module_id === value
            )
            this.timelineStatus = selectedItem ? Number(selectedItem.timeline_status_id) : 0
        },
        previewInvoice(item) {
            const routeData = this.$router.resolve(
                `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
            );
            window.open(routeData.href, '_blank');
        },
        async loaddataLitigationCourtStatus() {
            const result = await api.getClientTimelineStatusCongFigByModule("Dispute Resolution");

            this.statuslist = (result.data || []).map(item => ({
                ...item,
                module_id: Number(item.module_id)
            }));

        },
        //end

        // ---------- A · Client decision ----------
        async setClientDecision(value) {
            if (!this.nonCloseStatus || value === this.form.clientDecision) return;

            // ข้อมูลคดีเดิมจะถูกเก็บไว้เสมอ (Do not proceed แสดงแบบ read-only) จึงไม่ต้องยืนยันก่อนเปลี่ยน
            this.form.clientDecision = value;

            if (value === DECISION.AWAITING) {
                // ยังไม่ได้ตัดสินใจ → ไม่มีวันที่ตัดสินใจ
                this.form.decisionDate = "";
            } else if (!this.form.decisionDate) {
                this.form.decisionDate = moment().format("YYYY-MM-DD");
            }

            // Do not proceed: ถ้าเลือก Sales Order ไว้แล้ว → ใช้ลูกค้าตาม SO สำหรับวางบิล
            if (this.clientFollowsSO && this.form.salesOrderId) {
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                if (so && so.client_id) this.form.clientId = Number(so.client_id);
            }

            // Proceed: กางการ์ด B ให้กรอกข้อมูลคดีต่อได้ทันที
            if (value === DECISION.PROCEED) this.openSections.B = true;

            // Proceed: ตั้งทนายผู้รับผิดชอบเริ่มต้นเป็นผู้ให้คำปรึกษา (แก้ได้)
            if (value === DECISION.PROCEED && !this.form.lawyerId && this.form.advisingLawyerId) {
                this.form.lawyerId = this.form.advisingLawyerId;
            }
        },

        // ---------- ทุนทรัพย์: ใส่ , คั่นหลักพันระหว่างพิมพ์ ----------
        // ล้างให้เหลือเฉพาะตัวเลข + จุดทศนิยม 1 จุด (ไม่เกิน 2 ตำแหน่ง) เช่น "1,234.567" → "1234.56"
        normalizeAmount(value) {
            let s = String(value ?? "").replace(/[^\d.]/g, "");
            const dot = s.indexOf(".");
            if (dot !== -1) {
                s = s.slice(0, dot + 1) + s.slice(dot + 1).replace(/\./g, "").slice(0, 2);
            }
            s = s.replace(/^0+(?=\d)/, "");   // ตัด 0 นำหน้า เช่น "007" → "7"
            if (s.startsWith(".")) s = "0" + s; // ".5" → "0.5"
            return s;
        },
        // "1234567.5" → "1,234,567.5"
        formatAmount(raw) {
            if (raw === "" || raw == null) return "";
            const [intPart, decPart] = String(raw).split(".");
            const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return decPart !== undefined ? `${intFmt}.${decPart}` : intFmt;
        },
        onClaimAmountInput(value) {
            const field = this.$refs.claimAmountInput;
            const el = field?.$refs?.input;
            const typed = String(value ?? "");

            // นับจำนวนตัวเลข/จุด ที่อยู่ซ้ายของ cursor เพื่อคืนตำแหน่ง cursor หลังจัดรูปแบบ
            const caret = el ? el.selectionStart : null;
            const sigLeft = caret == null
                ? null
                : typed.slice(0, caret).replace(/[^\d.]/g, "").length;

            const raw = this.normalizeAmount(typed);
            const formatted = this.formatAmount(raw);

            this.form.claimAmount = raw;          // ค่าจริงที่ส่งไป API (ไม่มี ,)
            this.claimAmountDisplay = formatted;

            this.$nextTick(() => {
                if (!el) return;
                // บังคับ sync กรณีพิมพ์ตัวอักษรที่ถูกตัดทิ้ง (ค่า display ไม่เปลี่ยน Vue จึงไม่ re-render)
                if (field && "lazyValue" in field) field.lazyValue = formatted;
                el.value = formatted;

                if (sigLeft == null || document.activeElement !== el) return;
                let pos = 0;
                let seen = 0;
                while (pos < formatted.length && seen < sigLeft) {
                    if (/[\d.]/.test(formatted[pos])) seen++;
                    pos++;
                }
                el.setSelectionRange(pos, pos);
            });
        },
        onClaimAmountBlur() {
            // ตัดจุดที่ค้างท้าย เช่น "1,000." → "1,000"
            if (String(this.form.claimAmount).endsWith(".")) {
                this.form.claimAmount = this.form.claimAmount.slice(0, -1);
            }
            this.claimAmountDisplay = this.formatAmount(this.form.claimAmount);
        },

        openTimePicker(event) {
            const input = event?.target?.closest('.v-text-field')?.querySelector('input[type="time"]');
            if (input && typeof input.showPicker === 'function') {
                input.showPicker();
            }
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = String(date).slice(0, 10).split("-");
            return `${day}/${month}/${year}`;
        },
        onMainLawyerChange() {
            if (!this.form.lawyerId) {
                // ถ้าล้างทนายหลัก ปิดช่องทนายร่วม + เคลียร์
                this.showCoLawyer = false;
                this.additionalLawyers = [];
                return;
            }
            // ถ้าเลือกทนายหลักชนกับทนายร่วม ให้ดึงออก
            this.additionalLawyers = this.additionalLawyers.filter(
                id => id !== this.form.lawyerId
            );
        },
        closeCoLawyer() {
            this.showCoLawyer = false;
            this.additionalLawyers = [];
        },
        // ---------- DEV: จำลองข้อมูลไว้ทดสอบ ----------
        // mode: "all" = กรอก A–E + เพิ่มนัด/กำหนดส่ง, "schedule" = เพิ่มเฉพาะนัด/กำหนดส่ง
        // - ใช้ค่าจริงจาก dropdown (ทนาย / ศาล / ลูกค้า ...) ตัวแรก ๆ ให้บันทึกได้จริง
        // - นัด / กำหนดส่ง "เพิ่มต่อท้าย" เสมอ ไม่ลบของเดิม
        // - ไม่แตะ Section F (Sales Order ต้องตรงกับลูกค้า) และรหัสคดี (ระบบออกให้ตอน Save)
        async fillMockData(mode) {
            const pick = (list, i = 0) => (list && list.length ? list[Math.min(i, list.length - 1)] : null);
            const idOf = (list, i = 0) => { const x = pick(list, i); return x ? x.id : null; };
            const day = (n) => moment().add(n, "days").format("YYYY-MM-DD");

            if (mode === "all") {
                const r = await Swal.fire({
                    icon: "warning",
                    title: "กรอกข้อมูลตัวอย่าง?",
                    html: "ข้อมูลใน Section A–E จะถูกแทนที่ด้วยข้อมูลตัวอย่าง<br/>(นัด / กำหนดส่งจะเพิ่มต่อท้าย ไม่ลบของเดิม)",
                    showCancelButton: true,
                    confirmButtonText: "กรอกเลย",
                    cancelButtonText: "ยกเลิก",
                    confirmButtonColor: "#0e3a5f",
                    reverseButtons: true,
                });
                if (!r.isConfirmed) return;

                const lawyer = idOf(this.lawyerList, 0);
                // A · Advice & Client Decision
                Object.assign(this.form, {
                    adviceDate: day(-10),
                    advisingLawyerId: lawyer,
                    adviceStatus: "provided",
                    adviceSummary: "[TEST] ลูกค้าถูกผิดสัญญาซื้อขาย ค้างชำระค่าสินค้า 1,250,000 บาท มีหลักฐานใบสั่งซื้อและใบส่งของครบ ความเสี่ยงต่ำ",
                    recommendedAction: "[TEST] ส่งหนังสือบอกกล่าวทวงถาม 15 วัน หากไม่ชำระให้ยื่นฟ้องคดีแพ่ง",
                    clientNote: "[TEST] ลูกค้ายืนยันทางอีเมล",
                });
                this.form.clientDecision = "proceed";
                this.form.decisionDate = day(-7);
                // B · Case Identification
                Object.assign(this.form, {
                    blackNo: "พ.1234/2569",
                    redNo: "",
                    clientId: idOf(this.clientList, 0),
                    charge: "[TEST] ผิดสัญญาซื้อขาย เรียกค่าเสียหาย",
                    court: idOf(this.courtList, 0),
                    department: idOf(this.departmentList, 0),
                    caseType: idOf(this.caseTypeList, 0),
                    courtLevel: idOf(this.courtLevelList, 0) ?? this.form.courtLevel,
                    lawyerId: lawyer,
                    claimAmount: "1250000",
                });
                this.claimAmountDisplay = this.formatAmount(this.form.claimAmount);
                // C · Parties
                this.form.plaintiffs = "บริษัท ทดสอบ จำกัด";
                this.form.defendants = "บริษัท ตัวอย่าง เทรดดิ้ง จำกัด\nนายสมมติ ทดลอง";
                // E · หมายเหตุ
                this.form.remark = "[TEST] ข้อมูลจำลองสำหรับทดสอบระบบ";
            }

            // D · นัดหมาย + กำหนดส่งเอกสาร (เพิ่มต่อท้าย)
            const court = this.form.court ?? idOf(this.courtList, 0);
            const other = idOf(this.attendeeOptions, 0);
            const assignee = other ?? this.form.lawyerId ?? idOf(this.lawyerList, 0);
            const base = { id: 0, courtId: court, attendees: [], note: "" };
            // นัดทดสอบแจ้งเตือน 2 ชม.: อีก ~2.5 ชม. (ปัดขึ้นเป็นนาที 00/15/30/45) → job รอบ 15 นาทีจะส่ง 2h ภายใน ~30 นาที
            const soon = moment().add(150, "minutes");
            soon.minutes(Math.ceil(soon.minutes() / 15) * 15).seconds(0);
            const soonEnd = soon.clone().add(1, "hour");
            this.form.hearings.push(
                {
                    ...base, topic: "นัดพิจารณาคดี", date: soon.format("YYYY-MM-DD"), time: soon.format("HH:mm"),
                    endTime: soonEnd.isSame(soon, "day") ? soonEnd.format("HH:mm") : "",
                    location: "Courtroom 1", reminders: ["2h"], status: "not_started",
                    note: "[TEST] ทดสอบแจ้งเตือน 2 ชั่วโมงก่อนนัด"
                },
                {
                    ...base, topic: "นัดสืบพยานโจทก์", date: day(1), time: "09:00", endTime: "12:00",
                    location: "Courtroom 5", attendees: other ? [other] : [], reminders: ["7d", "1d", "2h"],
                    status: "not_started", note: "[TEST] เตรียมพยาน 2 ปาก + เอกสารหมาย จ.1–จ.5"
                },
                {
                    ...base, topic: "นัดไกล่เกลี่ย", date: day(7), time: "13:30", endTime: "15:00",
                    location: "ห้องไกล่เกลี่ย 2", reminders: ["7d", "1d"], status: "not_started"
                },
                {
                    ...base, topic: "นัดหมายกับลูกค้า", date: day(3), time: "10:00", endTime: "11:00",
                    courtId: null, location: "Office / MS Teams", reminders: ["1d", "2h"], status: "in_progress"
                },
            );
            this.form.deadlines.push(
                {
                    id: 0, task: "[TEST] Prepare witness list", dueDate: day(2), dueTime: "16:30",
                    assigneeId: assignee, reminders: ["7d", "3d", "1d"], status: "in_progress"
                },
                {
                    id: 0, task: "[TEST] ยื่นบัญชีระบุพยาน", dueDate: day(5), dueTime: "",
                    assigneeId: assignee, reminders: ["3d", "1d"], status: "not_started"
                },
            );

            this.setAllSections(true);
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },

        // ---------- DEV: ทดสอบการแก้ไข (Edit scenario) ----------
        // ใช้กับคดีที่บันทึกข้อมูลทดสอบแล้ว (Fill all → SAVE → เปิดคดีนี้ใหม่)
        // แก้เฉพาะรายการที่มี id (บันทึกแล้ว) ให้ครบทุกเคส แล้วสรุปว่าหลัง SAVE ต้องเห็นอะไรใน DB
        async applyEditScenario() {
            const saved = (rows) => rows.filter(r => r.item.id && r.item.id !== 0);
            const H = saved(this.sortedAppointments).map(r => r.item);   // เรียงตามวันนัด
            const D = saved(this.sortedDeadlines).map(r => r.item);

            if (H.length < 3 || D.length < 2) {
                await Swal.fire({
                    icon: "info",
                    title: "ยังไม่มีข้อมูลที่บันทึกพอ",
                    html: `ต้องมีนัดที่บันทึกแล้วอย่างน้อย 3 รายการ และกำหนดส่ง 2 รายการ<br/>
                           (ตอนนี้ นัด ${H.length} / กำหนดส่ง ${D.length})<br/><br/>
                           ขั้นตอน: <b>Test data → Fill all sections → SAVE</b><br/>แล้วเปิดคดีนี้ใหม่ จากนั้นกด Edit scenario`,
                    confirmButtonColor: "#0e3a5f",
                });
                return;
            }

            const r = await Swal.fire({
                icon: "warning",
                title: "แก้ข้อมูลตามชุดทดสอบ?",
                html: "นัด / กำหนดส่งที่บันทึกแล้วจะถูกแก้ ลบ และเพิ่ม ตามเคสทดสอบ<br/>(ยังไม่บันทึกจนกว่าจะกด SAVE)",
                showCancelButton: true,
                confirmButtonText: "แก้เลย",
                cancelButtonText: "ยกเลิก",
                confirmButtonColor: "#0e3a5f",
                reverseButtons: true,
            });
            if (!r.isConfirmed) return;

            this.closeAppointmentEditor();
            this.closeDeadlineEditor();

            const stamp = moment().format("HH:mm");
            const day = (n) => moment().add(n, "days").format("YYYY-MM-DD");
            const lawyerIds = this.attendeeOptions.map(l => l.id);
            const label = (h) => `#${h.id} ${h.topic || h.task}`;
            const cases = [];   // [{ no, title, expect }]
            const add = (title, expect) => cases.push({ no: cases.length + 1, title, expect });

            // ---------- A–E: แก้ข้อมูลคดี ----------
            this.form.redNo = "พ.5678/2569";
            this.form.remark = `${String(this.form.remark || "").trim()}\n[EDIT-TEST ${stamp}] แก้ไขข้อมูลคดี`.trim();
            add("แก้ข้อมูลคดี: เลขคดีแดง + หมายเหตุ",
                "litigation_docket_case: red_no = พ.5678/2569, remark มีบรรทัด [EDIT-TEST]");

            // ---------- นัดหมาย ----------
            // H1: แก้หลายฟิลด์ + เลื่อนเวลา (วันเดิม) + เพิ่มผู้เข้าร่วม
            const h1 = H[0];
            const oldTime1 = h1.time;
            if (h1.time) h1.time = moment(h1.time, "HH:mm").add(1, "hour").format("HH:mm");
            if (h1.endTime) h1.endTime = moment(h1.endTime, "HH:mm").add(1, "hour").format("HH:mm");
            if (h1.endTime && h1.time && h1.endTime <= h1.time) h1.endTime = "";   // กันข้ามเที่ยงคืน
            h1.location = "Courtroom 8 (แก้ไข)";
            h1.note = `[EDIT-TEST ${stamp}] เลื่อนเวลา + เปลี่ยนห้อง`;
            const before1 = [...(h1.attendees || [])];
            const extra = lawyerIds.find(id => !before1.includes(id));
            h1.attendees = extra ? [...before1, extra] : before1;
            add(`นัด ${label(h1)}: เลื่อนเวลา ${oldTime1} → ${h1.time}, เปลี่ยนห้อง, เพิ่มผู้เข้าร่วม`,
                `id เดิม (ไม่สร้างใหม่), location/note เปลี่ยน, attendees = [${h1.attendees.join(", ")}] · เตือนรอบใหม่ เพราะเวลาเปลี่ยน`);

            // H2: เลื่อนวัน + เปลี่ยนรอบเตือน + ล้างผู้เข้าร่วมทั้งหมด
            const h2 = H[1];
            const oldDate2 = h2.date;
            h2.date = moment(h2.date).add(2, "days").format("YYYY-MM-DD");
            h2.reminders = ["1d", "2h"];
            h2.attendees = [];
            add(`นัด ${label(h2)}: เลื่อนวัน ${this.formatDate(oldDate2)} → ${this.formatDate(h2.date)}, รอบเตือน = 1d + 2h, ลบผู้เข้าร่วมทั้งหมด`,
                "date ใหม่, reminders = {1d,2h}, litigation_hearing_attendees ของนัดนี้ = 0 แถว");

            // H3: ยกเลิกนัด → ต้องไม่ส่งแจ้งเตือน
            const h3 = H[2];
            h3.status = "cancelled";
            add(`นัด ${label(h3)}: เปลี่ยนสถานะเป็น Cancelled`,
                "status = cancelled · ไม่อยู่ใน v_litigation_due_reminders");

            // H4: ลบนัด (ถ้ามี)
            if (H[3]) {
                const h4 = H[3];
                add(`นัด ${label(h4)}: ลบ`,
                    "แถวหายจาก litigation_hearings และผู้เข้าร่วมของนัดนี้หายตาม (cascade)");
                this.removeHearing(this.form.hearings.indexOf(h4));
            }

            // H5: เพิ่มนัดใหม่ในโหมดแก้ไข
            this.form.hearings.push({
                id: 0, topic: "นัดชี้สองสถาน", date: day(1), time: "14:00", endTime: "15:30",
                courtId: this.form.court ?? null, location: "Courtroom 3",
                attendees: lawyerIds.slice(0, 1), reminders: ["7d", "1d", "2h"],
                status: "not_started", note: `[EDIT-TEST ${stamp}] เพิ่มใหม่ตอนแก้ไข`,
            });
            add("เพิ่มนัดใหม่: นัดชี้สองสถาน พรุ่งนี้ 14:00",
                `แถวใหม่ใน litigation_hearings${lawyerIds.length ? " + ผู้เข้าร่วม 1 คน" : ""} · ส่งเตือน 1d ทันที`);

            // ---------- กำหนดส่งเอกสาร ----------
            // D1: ทำเสร็จ → completed_at ต้องถูกบันทึก
            const d1 = D[0];
            const wasDone = d1.status === "completed";
            d1.status = wasDone ? "in_progress" : "completed";
            add(`กำหนดส่ง ${label(d1)}: ${wasDone ? "Completed → In progress" : "เปลี่ยนเป็น Completed"}`,
                wasDone ? "status = in_progress, completed_at = NULL · กลับมาอยู่ในแจ้งเตือน"
                    : "status = completed, completed_at มีค่า · ไม่อยู่ใน v_litigation_due_reminders");

            // D2: เลื่อนวัน/เวลา + เปลี่ยนผู้รับผิดชอบ + เปลี่ยนรอบเตือน
            const d2 = D[1];
            const oldDue2 = d2.dueDate;
            d2.dueDate = moment(d2.dueDate).add(1, "days").format("YYYY-MM-DD");
            d2.dueTime = "10:00";
            const otherAssignee = this.lawyerList.map(l => l.id).find(id => id !== d2.assigneeId);
            if (otherAssignee) d2.assigneeId = otherAssignee;
            d2.reminders = ["1d"];
            add(`กำหนดส่ง ${label(d2)}: เลื่อน ${this.formatDate(oldDue2)} → ${this.formatDate(d2.dueDate)} 10:00, เปลี่ยนผู้รับผิดชอบ, รอบเตือน = 1d`,
                `due_date/due_time ใหม่, assignee_id = ${d2.assigneeId}, reminders = {1d}`);

            // D3: ลบ (ถ้ามี)
            if (D[2]) {
                const d3 = D[2];
                add(`กำหนดส่ง ${label(d3)}: ลบ`, "แถวหายจาก litigation_deadlines");
                this.removeDeadline(this.form.deadlines.indexOf(d3));
            }

            // D4: เพิ่มกำหนดส่งใหม่ในโหมดแก้ไข
            this.form.deadlines.push({
                id: 0, task: `[EDIT-TEST ${stamp}] ส่งคำให้การ`, dueDate: day(4), dueTime: "",
                assigneeId: this.form.lawyerId ?? this.lawyerList[0]?.id ?? null,
                reminders: ["3d", "1d"], status: "not_started",
            });
            add("เพิ่มกำหนดส่งใหม่: ส่งคำให้การ อีก 4 วัน (ไม่ระบุเวลา)",
                "แถวใหม่ใน litigation_deadlines, due_time = NULL");

            this.setAllSections(true);

            // ---------- สรุปเคส + สิ่งที่ต้องเห็นหลัง SAVE ----------
            const rows = cases.map(c => `
                <tr>
                    <td style="padding:6px 8px;vertical-align:top;color:#1f5fa8;font-weight:700;">${c.no}</td>
                    <td style="padding:6px 8px;vertical-align:top;">
                        <div style="color:#1f2733;">${c.title}</div>
                        <div style="color:#5b6776;font-size:12px;margin-top:2px;">✔ ${c.expect}</div>
                    </td>
                </tr>`).join("");
            await Swal.fire({
                icon: "success",
                title: `แก้ข้อมูลแล้ว ${cases.length} เคส`,
                html: `
                    <div style="text-align:left;font-size:13px;">
                        กด <b>SAVE</b> แล้วเปิดคดีนี้ใหม่ / เช็กใน DB ตามรายการนี้
                        <table style="width:100%;margin-top:8px;border-collapse:collapse;">${rows}</table>
                    </div>`,
                width: 720,
                confirmButtonText: "ตกลง",
                confirmButtonColor: "#0e3a5f",
            });
        },

        // ---------- DEV: จำลองการแก้ไข (โหมด Edit) ----------
        // ใช้กับคดีที่บันทึกนัด/กำหนดส่งไว้แล้ว (แนะนำ: Fill all sections → SAVE → เปิดคดีอีกครั้ง → Edit scenario → SAVE)
        // ครอบคลุม: แก้ไขฟิลด์ทั่วไป, เลื่อนวัน/เวลา, เปลี่ยนผู้เข้าร่วม, เปลี่ยนสถานะ, ลบ, เพิ่มใหม่ปนกับของเดิม
        async fillMockEdit() {
            if (this.modeOperations !== "Edit") return;
            this.closeAppointmentEditor();
            this.closeDeadlineEditor();

            const shiftDate = (d, n) => moment(d).add(n, "days").format("YYYY-MM-DD");
            const shiftTime = (t, h) => (t ? moment(t, "HH:mm").add(h, "hours").format("HH:mm") : "10:00");
            const savedH = this.form.hearings.map((h, i) => ({ h, i })).filter(x => x.h.id && x.h.id !== 0);
            const savedD = this.form.deadlines.map((d, i) => ({ d, i })).filter(x => x.d.id && x.d.id !== 0);
            if (!savedH.length && !savedD.length) {
                Swal.fire({
                    icon: "info",
                    title: "ยังไม่มีข้อมูลที่บันทึกไว้",
                    html: "ใช้ <b>Fill all sections</b> → SAVE แล้วเปิดคดีนี้อีกครั้งก่อน",
                    confirmButtonColor: "#0e3a5f",
                });
                return;
            }

            const done = [];   // สิ่งที่แก้ → ให้ tester เช็ก
            const other = (ids) => this.attendeeOptions.find(o => !(ids || []).includes(o.id));

            // ----- นัดหมาย -----
            if (savedH[0]) {   // 1) เลื่อนวัน + เวลา + สถานะ → ต้องเตือนรอบใหม่
                const h = savedH[0].h;
                const before = `${this.formatDate(h.date)} ${h.time}`;
                h.date = shiftDate(h.date, 1);
                h.time = shiftTime(h.time, 1);
                h.endTime = h.endTime ? shiftTime(h.endTime, 1) : "";
                h.status = "in_progress";
                done.push(`นัด #${h.id}: เลื่อน ${before} → ${this.formatDate(h.date)} ${h.time}, สถานะ In progress`);
            }
            if (savedH[1]) {   // 2) ผู้เข้าร่วม + ห้อง + การแจ้งเตือน + หมายเหตุ (วัน/เวลาเดิม)
                const h = savedH[1].h;
                const o = other(h.attendees);
                const beforeAtt = (h.attendees || []).length;
                h.attendees = beforeAtt ? [] : (o ? [o.id] : []);
                h.location = "[TEST-EDIT] ห้อง 9";
                h.reminders = ["1d"];
                h.note = "[TEST-EDIT] แก้หมายเหตุ";
                done.push(`นัด #${h.id}: ผู้เข้าร่วม ${beforeAtt} → ${h.attendees.length} คน, ห้อง/หมายเหตุ/แจ้งเตือน (1d) เปลี่ยน`);
            }
            if (savedH[2]) {   // 3) ยกเลิกนัด → ต้องไม่แจ้งเตือน
                savedH[2].h.status = "cancelled";
                done.push(`นัด #${savedH[2].h.id}: เปลี่ยนเป็น Cancelled`);
            }
            if (savedH.length >= 4) {   // 4) ลบนัด (ลบจากท้ายก่อน index จะได้ไม่เลื่อน)
                const last = savedH[savedH.length - 1];
                done.push(`นัด #${last.h.id}: ลบ`);
                this.removeHearing(last.i);
            }

            // ----- กำหนดส่งเอกสาร -----
            if (savedD[0]) {   // 5) Completed → completed_at
                savedD[0].d.status = "completed";
                done.push(`กำหนดส่ง #${savedD[0].d.id}: Completed (ต้องมี completed_at)`);
            }
            if (savedD[1]) {   // 6) เลื่อนวัน + ใส่เวลา + เปลี่ยนผู้รับผิดชอบ
                const d = savedD[1].d;
                const o = this.lawyerList.find(l => l.id !== d.assigneeId);
                d.dueDate = shiftDate(d.dueDate, 2);
                d.dueTime = d.dueTime || "15:00";
                if (o) d.assigneeId = o.id;
                done.push(`กำหนดส่ง #${d.id}: เลื่อนเป็น ${this.formatDate(d.dueDate)} ${d.dueTime}, ผู้รับผิดชอบ → ${this.lawyerName(d.assigneeId)}`);
            }
            if (savedD.length >= 3) {   // 7) ลบกำหนดส่ง
                const last = savedD[savedD.length - 1];
                done.push(`กำหนดส่ง #${last.d.id}: ลบ`);
                this.removeDeadline(last.i);
            }

            // ----- 8) เพิ่มใหม่ปนกับของเดิม -----
            this.form.hearings.push({
                id: 0, topic: "นัดฟังคำพิพากษา", date: moment().add(5, "days").format("YYYY-MM-DD"), time: "09:30", endTime: "",
                courtId: this.form.court ?? null, location: "[TEST-EDIT] นัดใหม่", attendees: [], reminders: ["7d", "1d"],
                status: "not_started", note: "",
            });
            this.form.deadlines.push({
                id: 0, task: "[TEST-EDIT] กำหนดส่งใหม่", dueDate: moment().add(4, "days").format("YYYY-MM-DD"), dueTime: "",
                assigneeId: this.form.lawyerId ?? null, reminders: ["1d"], status: "not_started",
            });
            done.push("เพิ่มนัดใหม่ 1 + กำหนดส่งใหม่ 1 (id ต้องได้เลขใหม่ ไม่ทับของเดิม)");

            this.openSections.D = true;
            Swal.fire({
                icon: "success",
                title: "จำลองการแก้ไขแล้ว — กด SAVE แล้วเช็ก",
                html: `<div style="text-align:left;font-size:13px;line-height:1.7">${done.map(t => `• ${t}`).join("<br/>")}</div>`,
                width: 600,
                confirmButtonColor: "#0e3a5f",
            });
        },

        // ---------- การ์ด A–F ----------
        toggleSection(key) {
            this.openSections[key] = !this.openSections[key];
        },
        setAllSections(open) {
            Object.keys(this.openSections).forEach(k => { this.openSections[k] = open; });
        },

        // ---------- D · Case appointments ----------
        newAppointment() {
            return {
                id: 0, topic: "", date: "", time: "", endTime: "",
                courtId: this.form.court ?? null, location: "",
                attendees: [], reminders: ["7d", "1d", "2h"],
                status: "not_started", note: "", menu: false,
            };
        },
        // index = -1 → เพิ่มใหม่, ไม่งั้นแก้ไขรายการเดิม
        openAppointmentEditor(index = -1) {
            if (this.caseLocked) return;
            const src = index > -1 ? this.form.hearings[index] : this.newAppointment();
            this.apptDraft = {
                ...this.newAppointment(),
                ...src,
                attendees: [...(src.attendees || [])],
                reminders: [...(src.reminders || [])],
                ...this.splitAppointmentType(src.topic),
                menu: false,
            };
            // สถานะเก่าที่ไม่อยู่ในรายการ → Not started
            if (!this.appointmentStatusList.some(x => x.value === this.apptDraft.status)) this.apptDraft.status = "not_started";
            this.apptEditor = { open: true, index: typeof index === "number" ? index : -1, submitted: false };
            if (index > -1) this.scrollToEditor("apptEditorEl");
        },
        // ยกเลิก/ล้างฟอร์ม → กลับเป็นฟอร์มเพิ่มนัดใหม่ (ฟอร์มไม่ปิด)
        closeAppointmentEditor() {
            this.apptDraft = { ...this.newAppointment(), topicType: "", topicOther: "" };
            this.apptEditor = { open: true, index: -1, submitted: false };
        },
        saveAppointment() {
            this.apptEditor.submitted = true;
            if (Object.keys(this.apptErrors).length) return;
            const { menu, topicType, topicOther, ...data } = this.apptDraft; // eslint-disable-line no-unused-vars
            data.topic = topicType === OTHER_TYPE ? String(topicOther).trim() : topicType;
            if (this.apptEditor.index > -1) {
                this.$set(this.form.hearings, this.apptEditor.index, data);
            } else {
                this.form.hearings.push(data);
            }
            this.closeAppointmentEditor();
        },
        removeHearing(index) {
            const h = this.form.hearings[index];
            if (h.id && h.id !== 0) {
                this.deletedHearings.push(h.id);
            }
            this.form.hearings.splice(index, 1);
            if (this.apptEditor.index === index) this.closeAppointmentEditor();
            else if (this.apptEditor.index > index) this.apptEditor.index--;
        },

        // ---------- D · Document deadlines (UI only — ยังไม่ต่อ API) ----------
        newDeadline() {
            return {
                id: 0, task: "", dueDate: "", dueTime: "",
                assigneeId: this.form.lawyerId ?? null,
                reminders: ["7d", "3d", "1d"], status: "not_started", menu: false,
            };
        },
        openDeadlineEditor(index = -1) {
            if (this.caseLocked) return;
            const src = index > -1 ? this.form.deadlines[index] : this.newDeadline();
            this.deadlineDraft = { ...this.newDeadline(), ...src, reminders: [...(src.reminders || [])], menu: false };
            if (!this.deadlineStatusList.some(x => x.value === this.deadlineDraft.status)) this.deadlineDraft.status = "not_started";
            this.deadlineEditor = { open: true, index: typeof index === "number" ? index : -1, submitted: false };
            if (index > -1) this.scrollToEditor("deadlineEditorEl");
        },
        buildEntries(rows) {
            return [
                { kind: "new", index: -1 },
                { kind: "title", index: -2 },
                ...(rows.length ? [] : [{ kind: "empty", index: -3 }]),
                ...rows.map(r => ({ kind: "row", ...r })),
            ];
        },
        scrollToEditor(ref) {
            this.$nextTick(() => {
                let el = this.$refs[ref];
                if (Array.isArray(el)) el = el[0];   // ref ใน v-for เป็น array
                if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "nearest" });
            });
        },
        closeDeadlineEditor() {
            this.deadlineDraft = this.newDeadline();
            this.deadlineEditor = { open: true, index: -1, submitted: false };
        },
        saveDeadline() {
            this.deadlineEditor.submitted = true;
            if (Object.keys(this.deadlineErrors).length) return;
            const { menu, ...data } = this.deadlineDraft; // eslint-disable-line no-unused-vars
            data.task = String(data.task).trim();
            if (this.deadlineEditor.index > -1) {
                this.$set(this.form.deadlines, this.deadlineEditor.index, data);
            } else {
                this.form.deadlines.push(data);
            }
            this.closeDeadlineEditor();
        },
        removeDeadline(index) {
            const d = this.form.deadlines[index];
            if (d && d.id && d.id !== 0) this.deletedDeadlines.push(d.id);
            this.form.deadlines.splice(index, 1);
            if (this.deadlineEditor.index === index) this.closeDeadlineEditor();
            else if (this.deadlineEditor.index > index) this.deadlineEditor.index--;
        },

        // ---------- D · helpers ประเภทนัด / สถานะ ----------
        // topic ที่เก็บไว้ → ค่าในฟอร์ม (ถ้าไม่อยู่ในรายการ ถือเป็น "อื่นๆ" แล้วใส่ข้อความเดิมให้แก้ต่อ)
        splitAppointmentType(topic) {
            if (!topic) return { topicType: "", topicOther: "" };
            const known = this.appointmentTypeList.some(t => t.value === topic && t.value !== OTHER_TYPE);
            return known ? { topicType: topic, topicOther: "" } : { topicType: OTHER_TYPE, topicOther: topic };
        },
        appointmentTypeEn(topic) {
            const t = this.appointmentTypeList.find(x => x.value === topic && x.value !== OTHER_TYPE);
            return t ? t.en : "";
        },
        // เลยกำหนด = ตั้งสถานะ Overdue เอง หรือเลยวัน/เวลาแล้วแต่ยังไม่ Completed / Cancelled
        isDeadlineOverdue(d) {
            if (d.status === "overdue") return true;
            if (d.status === "completed" || d.status === "cancelled") return false;
            return this.isPast(d.dueDate, d.dueTime || "23:59");
        },

        // ---------- D · helpers สำหรับแสดงผล ----------
        lawyerName(id) {
            const l = this.lawyerList.find(x => x.id === id);
            return l ? l.name : "";
        },
        courtName(id) {
            if (id === null || id === undefined || id === "") return "";
            const c = this.courtList.find(x => x.id === id);
            return c ? c.name : "";
        },
        statusText(list, value) {
            const s = list.find(x => x.value === value);
            return s ? s.text : (value || "—");
        },
        statusTone(list, value) {
            const s = list.find(x => x.value === value);
            return s ? s.tone : "grey";
        },
        reminderSummary(options, values) {
            const parts = options.filter(o => (values || []).includes(o.value)).map(o => o.short);
            return parts.length ? `${parts.join(", ")} before` : "";
        },
        tileDay(date) {
            return date ? moment(date).format("DD") : "--";
        },
        tileMonth(date) {
            return date ? moment(date).locale("en").format("MMM").toUpperCase() : "";
        },
        tileYear(date) {
            return date ? moment(date).format("YYYY") : "";
        },
        isPast(date, time) {
            if (!date) return false;
            return moment.tz(`${date} ${time || "23:59"}`, "YYYY-MM-DD HH:mm", "Asia/Bangkok").isBefore(moment());
        },
        onFilesSelected(files) {
            if (!files || !files.length) return;
            const list = Array.isArray(files) ? files : [files];

            list.forEach(file => {
                if (file.type !== 'application/pdf') return;   // ✅ เช็คในนี้ ทีละไฟล์

                const uniqueName = this.getUniqueName(file.name);
                const finalFile = uniqueName === file.name
                    ? file
                    : new File([file], uniqueName, { type: file.type });

                this.form.files.push({
                    name: uniqueName,
                    raw: finalFile,
                    url: URL.createObjectURL(finalFile),
                });
            });

            this.pendingFiles = [];
        },

        getUniqueName(name) {
            const existing = this.form.files.map(f => f.name);
            if (!existing.includes(name)) return name;

            // แยกชื่อกับนามสกุล
            const dot = name.lastIndexOf('.');
            const base = dot === -1 ? name : name.slice(0, dot);
            const ext = dot === -1 ? '' : name.slice(dot);

            let i = 1;
            let candidate = `${base}_${i}${ext}`;
            while (existing.includes(candidate)) {
                i++;
                candidate = `${base}_${i}${ext}`;
            }
            return candidate;
        },

        previewFile(f) {
            // เปิด PDF ในแท็บใหม่
            window.open(f.url, '_blank');
        },

        removeFile(index) {
            const f = this.form.files[index];

            if (f.isExisting) {
                // ไฟล์เก่าจาก server → จำไว้เพื่อไปลบตอน save
                this.deletedFiles.push({
                    id: f.id,
                    name: f.name,
                });
            } else if (f.url) {
                // ไฟล์ใหม่ → คืน memory ของ object URL
                URL.revokeObjectURL(f.url);
            }

            this.form.files.splice(index, 1);
        },
        onSelectSO(so) {
            // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
            if (!so) {
                this.form.price = "";
                this.form.customerName = "";
                this.form.currency = "";
                this.quotationscheckstatus = "";
                // Do not proceed (ไม่มีข้อมูลคดี): ลูกค้ามาจาก SO → เคลียร์ตาม
                if (this.clientFollowsSO) this.form.clientId = null;
                return;
            }
            // Do not proceed (ไม่มีข้อมูลคดี): ช่องลูกค้าถูกซ่อน → ใช้ลูกค้าจาก Sales Order สำหรับวางบิล
            if (this.clientFollowsSO && so.client_id) {
                this.form.clientId = Number(so.client_id);
            }
            this.quotationscheckstatus = so.status;
            this.form.price = Number(so.subtotal);
            this.form.customerName = so.customer_name || "";
            this.form.currency = so.currency || "";
        },

        // ตรวจช่องบังคับจาก "ข้อมูล" โดยตรง ไม่พึ่ง v-form
        // เพราะตอนอยู่แท็บ Internal Timeline ช่องในแท็บ Internal Work ไม่ได้ render → validate() ผ่านเสมอ
        getMissingRequiredFields() {
            const f = this.form;
            const isEmpty = (v) => v === null || v === undefined || String(v).trim() === "";
            const missing = [];   // [{ section: "A" | "B", label }]
            const add = (section, label) => missing.push({ section, label });

            // A · Advice & Client Decision
            if (isEmpty(f.adviceDate)) add("A", "วันที่ให้คำปรึกษา (Advice date)");
            if (isEmpty(f.advisingLawyerId)) add("A", "ผู้ให้คำปรึกษา (Advising lawyer)");
            if (isEmpty(f.adviceSummary)) add("A", "สรุปคำแนะนำ (Advice summary)");
            if (isEmpty(f.clientDecision)) add("A", "การตัดสินใจของลูกค้า (Client decision)");
            if (this.isDeclined && isEmpty(f.clientNote)) {
                add("A", "เหตุผล / หมายเหตุจากลูกค้า (Reason / client note)");
            }

            // B · Case Identification — บังคับเฉพาะ Proceed with case
            if (this.isProceed) {
                if (isEmpty(f.clientId)) add("B", "ลูกค้า (Client)");
                if (isEmpty(f.lawyerId)) add("B", "ทนายผู้รับผิดชอบ");
            }
            return missing;
        },

        // dialog แจ้งเตือนกรอกข้อมูลไม่ครบ — ปุ่มสีเดียวกับ SAVE (navy #0e3a5f)
        // หมายเหตุ: Swal render นอก component → ใช้ inline style (scoped CSS ไม่มีผล)
        showMissingFieldsDialog(missing = []) {
            // กางการ์ดที่มีช่องขาด ให้ผู้ใช้เห็นช่องที่ต้องกรอก
            missing.forEach(m => {
                if (m.section in this.openSections) this.openSections[m.section] = true;
            });
            const sectionTitles = {
                A: "A · คำปรึกษาและการตัดสินใจของลูกค้า",
                B: "B · ข้อมูลคดี",
            };

            const groupsHtml = Object.keys(sectionTitles)
                .map(sec => {
                    const items = missing.filter(m => m.section === sec);
                    if (!items.length) return "";
                    const rows = items.map(m => `
                        <div style="display:flex;align-items:center;gap:10px;padding:6px 0;">
                            <span style="flex:0 0 auto;width:6px;height:6px;border-radius:50%;background:#c0392b;"></span>
                            <span style="color:#1f2733;font-size:13.5px;">${m.label}</span>
                        </div>`).join("");
                    return `
                        <div style="text-align:left;background:#f7f9fb;border:1px solid #e2e6ec;
                                    border-left:3px solid #1b7a99;border-radius:8px;
                                    padding:10px 14px;margin-top:10px;">
                            <div style="font-size:11px;font-weight:700;letter-spacing:.8px;
                                        text-transform:uppercase;color:#1b7a99;margin-bottom:2px;">
                                ${sectionTitles[sec]}
                            </div>
                            ${rows}
                        </div>`;
                })
                .join("");

            const subtitle = missing.length
                ? `ยังขาดข้อมูลที่จำเป็น <b style="color:#c0392b">${missing.length} รายการ</b> กรุณากรอกให้ครบก่อนบันทึก`
                : `โปรดกรอกช่องที่มีเครื่องหมาย <b style="color:#c0392b">*</b> ให้ครบก่อนบันทึก`;

            return Swal.fire({
                icon: "warning",
                iconColor: "#c47f00",
                title: "กรุณากรอกข้อมูลให้ครบ",
                html: `
                    <div style="font-size:14px;color:#4a5563;">${subtitle}</div>
                    ${groupsHtml}`,
                width: 480,
                padding: "1.6em 1.6em 1.4em",
                confirmButtonText: "ตกลง",
                // ปิดสไตล์ปุ่มของ Swal ทั้งหมด (กัน theme ของ Swal / global CSS ทับสี) แล้วกำหนดเองให้เหมือน SAVE
                buttonsStyling: false,
                focusConfirm: false,
                didOpen: () => {
                    const btn = Swal.getConfirmButton();
                    if (!btn) return;

                    // ดึงสีจริงจากปุ่ม SAVE บนหน้า → ได้สีเดียวกันแน่นอนแม้ theme จะเปลี่ยน
                    const saveBtn = this.$el && this.$el.querySelector(".navy-btn");
                    const saveStyle = saveBtn ? window.getComputedStyle(saveBtn) : null;
                    const bg = (saveStyle && saveStyle.backgroundColor
                        && saveStyle.backgroundColor !== "rgba(0, 0, 0, 0)")
                        ? saveStyle.backgroundColor
                        : "#0e3a5f";
                    const fg = saveStyle ? saveStyle.color : "#ffffff";

                    const set = (prop, value) => btn.style.setProperty(prop, value, "important");
                    set("background-color", bg);
                    set("background-image", "none");
                    set("color", fg);
                    set("border", "none");
                    set("border-radius", "4px");
                    set("min-width", "120px");
                    set("height", "36px");
                    set("padding", "0 32px");
                    set("font-size", "14px");
                    set("font-weight", "500");
                    set("letter-spacing", "1.25px");
                    set("text-transform", "uppercase");
                    set("box-shadow", "none");
                    set("cursor", "pointer");
                    set("margin", "8px 0 0");

                    // hover เข้มขึ้นเล็กน้อยแบบ v-btn
                    btn.addEventListener("mouseenter", () => set("filter", "brightness(1.15)"));
                    btn.addEventListener("mouseleave", () => set("filter", "none"));
                    const title = Swal.getTitle();
                    if (title) Object.assign(title.style, {
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#1f2733",
                    });
                },
            });
        },

        async onSave(mode) {

            // ----- ดักช่องบังคับก่อน (ทำงานได้ทั้งจากแท็บ Internal Work และ Internal Timeline) -----
            const missing = this.getMissingRequiredFields();
            if (missing.length > 0) {
                // พากลับไปแท็บ Internal Work แล้วให้ v-form ขึ้นกรอบแดงตรงช่องที่ขาด
                this.tabselect = 0;
                await this.$nextTick();
                this.$refs.form && this.$refs.form.validate();
                await this.$nextTick();
                const firstError = this.$el.querySelector(".error--text");
                if (firstError) firstError.scrollIntoView({ behavior: "smooth", block: "center" });

                this.showMissingFieldsDialog(missing);
                return;
            }

            // ----- Section D: มีนัด / กำหนดส่งกรอกค้างไว้ → ถามก่อน -----
            if (!(await this.resolveUnsavedScheduleDraft())) return;

            if (this.$refs.form.validate()) {


                // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่เลือกในคดีนี้
                // กันเคสผูก Quotation ของลูกค้าคนอื่นเข้ากับคดี ทำให้วางบิลผิดคน
                // (Awaiting ล็อกอยู่ ไม่ต้องตรวจ)
                if (!this.isAwaiting && this.form.salesOrderId) {
                    const selectedSO = this.salesOrderList.find(
                        item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                    );

                    if (!selectedSO) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }

                    // Do not proceed (ไม่มีข้อมูลคดี): ไม่มีช่องเลือกลูกค้า → ผูกลูกค้าตาม Sales Order
                    // ถ้ามีข้อมูลคดีอยู่แล้ว ใช้ลูกค้าเดิมของคดี และตรวจว่าตรงกับ SO ตามปกติ
                    if (this.clientFollowsSO) {
                        this.form.clientId = Number(selectedSO.client_id);
                    }

                    if (Number(selectedSO.client_id) !== Number(this.form.clientId)) {
                        Swal.fire({
                            icon: "warning",
                            title: "ข้อมูลลูกค้าไม่ตรงกัน",
                            html: `ใบเสนอราคา <b>${selectedSO.doc_no}</b> เป็นของลูกค้า <b>${selectedSO.customer_name || "-"}</b><br/>
                           ซึ่งไม่ตรงกับลูกค้าที่เลือกในคดีนี้<br/>
                           กรุณาตรวจสอบและเลือกใหม่ให้ถูกต้อง`,
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                }
                if (this.timelineStatus == 0 || this.status_note.trim() == "") {
                    this.dialogDelete = true;
                    return;
                }
                // helper: แปลง string ว่าง / undefined ให้เป็น null
                const toNull = (v) => (v === "" || v === undefined || v === null ? null : v);
                // helper: แปลงเป็นตัวเลข ถ้าว่างเป็น null
                const toNumber = (v) => {
                    if (v === "" || v === undefined || v === null) return null;
                    const n = Number(v);
                    return isNaN(n) ? null : n;
                };
                // ข้อมูลคดีเก็บตามที่มีอยู่เสมอ ไม่ว่าลูกค้าจะตัดสินใจแบบไหน (ไม่ล้างทิ้ง)
                const caseVal = (v) => v;

                // ---------- รหัสคดีภายใน ----------
                // ออกเลขรันใหม่เฉพาะเมื่อ Proceed และยังไม่เคยมีรหัส
                // รหัสเดิมเก็บไว้เสมอ (รวมถึงตอนเปลี่ยนเป็น Do not proceed / Awaiting)
                let internalCaseNo = this.form.internalCaseNo || null;
                if (this.isProceed && !internalCaseNo) {
                    const resdoc = await api.dispute_resolution_get_docruningDocket(Number(localStorage.getItem(server.COMPANYID)));
                    internalCaseNo = resdoc.data.data || null;
                    this.form.internalCaseNo = internalCaseNo || "";
                }

                var datalist = {
                    // ---------- A · Advice & Client Decision ----------
                    advice_date: toNull(this.form.adviceDate),
                    advising_lawyer_id: toNumber(this.form.advisingLawyerId),
                    advice_status: toNull(this.form.adviceStatus),
                    advice_summary: toNull(this.form.adviceSummary),
                    recommended_action: toNull(this.form.recommendedAction),
                    client_decision: this.form.clientDecision,
                    decision_date: this.isAwaiting ? null : toNull(this.form.decisionDate),
                    client_note: toNull(this.form.clientNote),
                    // ---------- B · Case Identification ----------
                    internal_case_no: internalCaseNo,                     // null เมื่อยังไม่ Proceed
                    black_no: caseVal(toNull(this.form.blackNo)),
                    client_id: toNumber(this.form.clientId),              // bigint
                    red_no: caseVal(toNull(this.form.redNo)),
                    charge: caseVal(toNull(this.form.charge)),
                    court: caseVal(toNumber(this.form.court)),            // int
                    department: caseVal(toNumber(this.form.department)),  // int
                    case_type: caseVal(toNumber(this.form.caseType)),     // int
                    court_level: caseVal(toNumber(this.form.courtLevel)), // int *
                    claim_amount: caseVal(toNumber(this.form.claimAmount)), // numeric
                    lawyer_id: caseVal(toNumber(this.form.lawyerId)),     // bigint
                    plaintiffs: caseVal(toNull(this.form.plaintiffs)),
                    defendants: caseVal(toNull(this.form.defendants)),
                    remark: caseVal(toNull(this.form.remark)),
                    case_status: toNumber(this.form.caseStatus),          // bigint
                    sales_order_id: toNumber(this.form.salesOrderId),     // F · ใช้ได้ทั้ง Proceed / Do not proceed
                    user_update: Number(localStorage.getItem(server.USER_ID)),
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                };
                try {
                    await this.$showLoader()
                    var res = [];
                    if (this.modeOperations == "New") {
                        datalist.user_create = Number(localStorage.getItem(server.USER_ID));
                        res = await api.dispute_resolution_add_docket(datalist)
                        var main_id = res.data.id;

                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(main_id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)
                        try {
                            const caseDetailResult = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

                            const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const timelineData = visibilityResult.data || [];

                            caseInfo.status = timelineData[0]?.status || '';
                            caseInfo.lastUpdated = timelineData[0]?.status_time || '';

                            const latestUpdate = {
                                message: timelineData[0]?.status_note || '',
                                date: timelineData[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo,
                                    latestUpdate,
                                    timelineData,
                                    caseId: Number(main_id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline
                        //add payment invoice
                        // ผูก Invoice ได้ทุกสถานะยกเว้น Awaiting decision
                        if (!this.isAwaiting && this.form.invoiceId) {
                            try {
                                // อัปเดตสถานะ Quotation: InProgress → Invoiced (ถ้ามี Quotation)
                                if (this.form.salesOrderId) {
                                    try {
                                        const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.form.salesOrderId));
                                        if (resQuotations.data.status == "InProgress") {
                                            var dataupdateStatusInvoiced = {
                                                status: "Invoiced"
                                            }
                                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatusInvoiced)
                                        }
                                    } catch (error) {
                                        console.log("loadQuotations Error")
                                    }
                                }

                                var dataadd_payment_invoice = {
                                    inv_id: Number(this.form.invoiceId),
                                    module_name: "Litigations",
                                    module_id: Number(main_id),
                                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                    department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
                                    quotation_id: toNumber(this.form.salesOrderId),
                                }
                                await api.billing_expense_create_payment_invoice(dataadd_payment_invoice)
                            } catch (paymentInvoiceError) {
                                console.error("Link payment invoice failed:", paymentInvoiceError);
                                // ไม่ throw ต่อ — ไม่ให้กระทบการบันทึกทนายร่วม/วันนัด/ไฟล์แนบ
                            }
                        }
                        //end add payment invoice

                        // ทนายร่วม + วันนัด: บันทึกทุกอย่างที่กรอกไว้ ไม่ว่าลูกค้าจะตัดสินใจแบบไหน
                        // (กรณีกรอกตอน Proceed แล้วเปลี่ยนเป็นสถานะอื่นก่อนกด Save ข้อมูลจะไม่หาย)
                        {
                            if (this.additionalLawyers.length > 0) {
                                for (const item of this.additionalLawyers) {
                                    var dataAdditionalLawyers = {
                                        litigation_docket_id: main_id,
                                        user_id: item,
                                        user_create: Number(localStorage.getItem(server.USER_ID)),
                                        user_update: Number(localStorage.getItem(server.USER_ID))
                                    }
                                    await api.dispute_resolution_add_additional_lawyers(dataAdditionalLawyers)
                                }

                            }

                        }

                        // D · นัดหมาย + กำหนดส่งเอกสาร
                        await this.saveScheduleItems(main_id);

                        // เอกสารแนบ: อัปโหลดทุกไฟล์ที่แนบไว้ (เก็บข้อมูลไว้เสมอ)
                        if (this.form.files.length > 0) {
                            for (const item of this.form.files) {
                                let formData = new FormData();
                                formData.append("file", item.raw);
                                formData.append("id", Number(main_id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                                await api.dispute_resolution_upload_file(formData)
                            }
                        }

                    } else {
                        await api.dispute_resolution_update_docket(Number(this.$route.params.id), datalist)
                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(this.$route.params.id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)

                        try {
                            const caseDetailResultEdit = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const caseInfoEdit = { ...(caseDetailResultEdit.data?.[0] || {}) };

                            const visibilityResultEdit = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const timelineDataEdit = visibilityResultEdit.data || [];

                            caseInfoEdit.status = timelineDataEdit[0]?.status || '';
                            caseInfoEdit.lastUpdated = timelineDataEdit[0]?.status_time || '';

                            const latestUpdateEdit = {
                                message: timelineDataEdit[0]?.status_note || '',
                                date: timelineDataEdit[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo: caseInfoEdit,
                                    latestUpdate: latestUpdateEdit,
                                    timelineData: timelineDataEdit,
                                    caseId: Number(this.$route.params.id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline
                        //add payment invoice
                        // ผูก Invoice ได้ทุกสถานะยกเว้น Awaiting decision
                        if (!this.isAwaiting && this.form.invoiceId) {
                            try {
                                // อัปเดตสถานะ Quotation: InProgress → Invoiced (ถ้ามี Quotation)
                                if (this.form.salesOrderId) {
                                    try {
                                        const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.form.salesOrderId));
                                        if (resQuotations.data.status == "InProgress") {
                                            var dataupdateStatusInvoiced = {
                                                status: "Invoiced"
                                            }
                                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatusInvoiced)
                                        }
                                    } catch (error) {
                                        console.log("loadQuotations Error")
                                    }
                                }

                                var dataadd_payment_invoice = {
                                    inv_id: Number(this.form.invoiceId),
                                    module_name: "Litigations",
                                    module_id: Number(this.$route.params.id),
                                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                    department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
                                    quotation_id: toNumber(this.form.salesOrderId),
                                }
                                await api.billing_expense_create_payment_invoice(dataadd_payment_invoice)
                            } catch (paymentInvoiceError) {
                                console.error("Link payment invoice failed:", paymentInvoiceError);
                                // ไม่ throw ต่อ — ไม่ให้กระทบการบันทึกทนายร่วม/วันนัด/ไฟล์แนบ
                            }
                        }
                        //end add payment invoice

                        //edit ทนายร่วม — diff ตามที่เลือกไว้ (ทุกสถานะ)
                        // Awaiting / Declined ช่องล็อกอยู่ แก้ไม่ได้ → ถ้ามีการเปลี่ยน แปลว่าแก้ตอน Proceed แล้วค่อยเปลี่ยนสถานะ
                        // จึงบันทึกตามที่แก้ไว้ ไม่ทิ้งข้อมูล
                        const oldIds = this.originalAdditionalLawyers;
                        const newIds = this.additionalLawyers;

                        // ตัวที่เพิ่มใหม่ = อยู่ใน new แต่ไม่อยู่ใน old
                        const added = newIds.filter(id => !oldIds.includes(id));

                        // ตัวที่ถูกลบ = อยู่ใน old แต่ไม่อยู่ใน new
                        const removed = oldIds.filter(id => !newIds.includes(id));

                        // insert ตัวที่เพิ่ม
                        for (const item of added) {
                            await api.dispute_resolution_add_additional_lawyers({
                                litigation_docket_id: Number(this.$route.params.id),
                                user_id: item,
                                user_create: Number(localStorage.getItem(server.USER_ID)),
                                user_update: Number(localStorage.getItem(server.USER_ID))
                            });
                        }

                        // delete ตัวที่ถูกเอาออก
                        for (const item of removed) {
                            await api.dispute_resolution_delete_additional_lawyer_by_user(
                                Number(this.$route.params.id),
                                item
                            );
                        }

                        // D · นัดหมาย + กำหนดส่งเอกสาร
                        // บันทึกตามที่แก้ไว้ทุกสถานะ (ไม่ลบข้อมูลเดิมเพราะเปลี่ยนการตัดสินใจของลูกค้า)
                        await this.saveScheduleItems(Number(this.$route.params.id));

                        // ----- เอกสารแนบ (ทำงานเหมือนข้อมูลคดี) -----
                        // ลบตัวที่ผู้ใช้กดลบ + อัปโหลดไฟล์ใหม่ (ทุกสถานะ — ไม่ลบไฟล์เพราะเปลี่ยนการตัดสินใจของลูกค้า)
                        {
                            // ----- ลบไฟล์เดิมที่ผู้ใช้กดลบ -----
                            for (const f of this.deletedFiles) {
                                await api.dispute_resolution_delete_file(Number(this.$route.params.id), f.id, f.name);
                            }

                            // ----- อัปโหลดเฉพาะไฟล์ใหม่ (ไฟล์เดิมข้าม) -----
                            for (const item of this.form.files) {
                                if (item.isExisting) continue;   // ไฟล์เดิมจาก server ไม่ต้อง upload ซ้ำ
                                let formData = new FormData();
                                formData.append("file", item.raw);
                                formData.append("id", Number(this.$route.params.id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                                await api.dispute_resolution_upload_file(formData);
                            }
                        }
                    }
                    await this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: this.modeOperations == "New" ? "เพิ่มสำเร็จ" : "แก้ไขสำเร็จ",
                        text: this.modeOperations == "New"
                            ? "เพิ่มข้อมูลคดีเรียบร้อยแล้ว"
                            : "บันทึกการแก้ไขเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                    try {
                        // เปลี่ยนสถานะ Quotation ได้ทุกสถานะยกเว้น Awaiting decision
                        if (!this.isAwaiting && this.quotationscheckstatus == "Submitted") {


                            var dataupdateStatus = {
                                status: "InProgress"
                            }
                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatus)
                        }
                    } catch (quotationsError) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                    if (mode == "Save") {

                        if (this.modeOperations == "New") {
                            this.$router.push(`/dispute-resolution-docket/${res.data.id}`);
                        } else {
                            this.$router.go(0);
                        }
                    } else {

                        var customer_name_master_show = this.clientList.find(
                            item => item.id === this.form.clientId
                        )?.name

                        var dataPush = {
                            customer_name_master: customer_name_master_show,
                            module_id: 0,
                            quotation_id: toNumber(this.form.salesOrderId),
                        }
                        if (this.modeOperations == "New") {
                            dataPush.module_id = Number(res.data.id);
                        } else {
                            dataPush.module_id = Number(this.$route.params.id);
                        }

                        this.$router.push({
                            path: `/new-free-invoice/0/invoice/D/${this.form.clientId}/Litigations`,
                            query: dataPush,
                        });
                    }
                } catch (error) {
                    await this.$hideLoader();
                    Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }
            } else {
                // กรณี rule อื่นใน v-form ไม่ผ่าน → ใช้ dialog รูปแบบเดียวกัน
                this.showMissingFieldsDialog();
            }
        },
        onCancel() {
            this.$router.push(`/litigation-overview`);
        },
    },
    beforeDestroy() {
        this.form.files.forEach(f => {
            if (f.raw && f.url) URL.revokeObjectURL(f.url);
        });
    }
};
